import imageCompression from "browser-image-compression";

/**
 * Compress an image File before upload.
 * Defaults: max 1600px on longest edge, JPEG quality 0.85, web-worker on.
 * Returns a new File (jpeg) or the original if compression fails or input isn't an image.
 */
export async function compressImage(file, opts = {}) {
  if (!file || !file.type?.startsWith("image/")) return file;
  // GIFs and SVGs — skip
  if (/(gif|svg)/i.test(file.type)) return file;

  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1600,
    initialQuality: 0.85,
    useWebWorker: true,
    fileType: "image/jpeg",
    ...opts,
  };

  try {
    const compressed = await imageCompression(file, options);
    // If somehow larger, return original
    if (compressed.size >= file.size) return file;
    // Ensure a sensible filename with .jpg extension
    const baseName = (file.name || "photo").replace(/\.[^.]+$/, "");
    return new File([compressed], `${baseName}.jpg`, { type: "image/jpeg", lastModified: Date.now() });
  } catch (e) {
    console.warn("Image compression failed, uploading original:", e);
    return file;
  }
}
